import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState, selectLanguageInCommonState } from 'app/app-state.index';
import { SubscriptionService } from 'app/public/services/subscription.service';
import { Language } from 'app/shared/model/enums';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss']
})
export class LandingPageComponent implements OnInit {
  @ViewChild('videoPlayer') videoplayer: ElementRef;
  isPlay = true;
  @ViewChild('videoPlayer') videoplayer2: ElementRef;
  isPlay2 = true;
  isMobileMenuOpen: boolean = false;

  currentContent: string
  subscriptions = new Subscription();
  language: Language
  cardsReasonsToChooseUs: { title: string; content: string }[] = [];
  cardsSetsApart: { title: string; content: string }[] = [];
  cardsHowItWork: { title: string; content: string }[] = [];

  urls: string[]
  constructor(private store: Store<AppState>, private router: Router) {
    this.subscriptions.add(store.select(selectLanguageInCommonState).subscribe(language => {
      this.loadData(language);
    }));
  }

  ngOnInit(): void {
  }
  loadData(language: Language) {
     if(language==Language.en||language==Language.bg){
      this.cardsHowItWork=this.cardsHowItWorkEn
    this.cardsReasonsToChooseUs=this.cardsReasonsToChooseUsEn
    this.cardsSetsApart=this.cardsSetsApartEn
     }
     else{
      this.cardsHowItWork=this.cardsHowItWorkHe
      this.cardsReasonsToChooseUs=this.cardsReasonsToChooseUsHe
      this.cardsSetsApart=this.cardsSetsApartHe
     }
    this.language = language
  
  }
 
  createRoulette() {
    this.router.navigate([`roulette`])
  }
  toggleVideo() {
    this.videoplayer.nativeElement.play();
    this.isPlay = true
  }
  toggleVideo2() {
    this.videoplayer2.nativeElement.play();
    this.isPlay2 = true
  }
  getAbsoluteUrl(relativePath: string, language: number): string {
    return `${window.location.origin}${relativePath}?language=${language}`;
  }

  isOpen(isOpen: boolean) {
    this.isMobileMenuOpen = isOpen;
  }
  cardsReasonsToChooseUsEn = [
    { title: 'Maximized ROI', content: 'Achieve impressive returns by turning casual visitors into repeat buyers. With Spin to Win, your investment pays for itself with measurable growth in customer engagement and revenue.' },
    { title: 'Effortless Integration & Customization', content: 'Seamlessly integrate Spin to Win into your business platform and create experiences that align with your brand identity. Tailor campaigns to fit your business needs with ease.' },
    { title: 'Simple & Accessible Technology', content: 'Whether youre a tech wizard or a self-proclaimed technophobe, Spin to Win is designed for everyone. Our user-friendly platform ensures that anyone can set up, customize, and use the tool with confidence and ease.' },
    { title: 'Proven Success Stories', content: 'From small startups to large enterprises, businesses across industries are using Spin to Win to revolutionize their customer experience.' },
    { title: 'Engaging, Gamified Rewards', content: 'Stand out from competitors with gamification that captures attention and keeps customers coming back for more.' },
    // { title: 'Card 6', content: 'This is the content of Card 6.' }
  ];
  cardsReasonsToChooseUsHe = [
    { title: 'טכנולוגיה פשוטה ונגישה', content: 'בין אם אתה אשף טכנולוגי או טכנופוב שהכריז על עצמו, Spin to Win מיועד לכולם. הפלטפורמה הידידותית למשתמש שלנו מבטיחה שכל אחד יוכל להגדיר, להתאים אישית ולהשתמש בכלי בביטחון ובקלות.' },
    { title: 'שילוב והתאמה אישית ללא מאמץ', content: 'שלב בצורה חלקה את Spin to Win בפלטפורמה העסקית שלך וצור חוויות שתואמות את זהות המותג שלך. התאם בקלות קמפיינים שיתאימו לצרכים העסקיים שלך.' }
    , { title: 'החזר השקעה מקסימלי', content: 'השג תשואות מרשימות על ידי הפיכת מבקרים מזדמנים לקונים חוזרים. עם Spin to Win, ההשקעה שלך משלמת על עצמה עם צמיחה מדידה במעורבות הלקוחות ובהכנסות.' },
    { title: 'תגמולים מרתקים ומשוחקים', content: 'התבלט מעל המתחרים עם Gamification שמושך תשומת לב וגורם ללקוחות לחזור ולבקש עוד.' }
    , { title: 'סיפורי הצלחה מוכחים', content: 'מסטארט-אפים קטנים ועד ארגונים גדולים, עסקים בתעשיות שונות משתמשים ב-Spin to Win כדי לחולל מהפכה בחוויית הלקוח שלהם.' }
  ]
  cardsSetsApartEn = [
    { title: 'Excitement and Enjoyment for Customers', content: 'The game creates anticipation and thrill, enhanced by background music and surprises that elevate the user experience.' },
    { title: 'Exceptional Conversion Rates', content: 'Unlike traditional methods yielding only 25%, Spin to Win achieves up to 90% customer detail retention!' },
    { title: 'Flexibility', content: 'Suitable for all types of businesses—toy stores, cosmetics shops, restaurants, and more.' },
    { title: 'Cost Efficiency', content: 'An affordable solution for small and medium-sized business owners compared to traditional U.S. customer clubs, which can cost $400+ per month.' },
    { title: 'Ongoing Engagement', content: 'Easily re-engage customers by sending recurring offers and prizes during slower periods, ensuring long-term loyalty.' }
  ]
  cardsSetsApartHe=[
    {title:'יחסי המרה יוצאי דופן:',content:'בניגוד לשיטות מסורתיות המניבות רק 25%, Spin to Win משיגה עד 90% שימור פרטי לקוחות!'},
    {title:'גמישות:',content:'מתאים לכל סוגי העסקים – חנויות צעצועים, חנויות קוסמטיקה, מסעדות ועוד.'},
    {title:'יעילות כלכלית:',content:'פתרון משתלם לבעלי עסקים קטנים ובינוניים בהשוואה למועדוני לקוחות מסורתיים בארה"ב, שיכול לעלות $400+ לחודש.'},
    {title:'מעורבות מתמשכת:',content:'צור מעורבות מחודשת בקלות של לקוחות על-ידי שליחת הצעות חוזרות ופרסים בתקופות איטיות יותר, כדי להבטיח נאמנות לטווח ארוך.'},
    {title:'התרגשות והנאה ללקוחות:',content:'המשחק יוצר ציפייה וריגוש, המועצמים על ידי מוזיקת רקע והפתעות המרוממות את חוויית המשתמש.'},
  ]
  cardsHowItWorkEn = [
    { title: 'Step 1', content: 'Integrate the Spin to Win tool on your website or in-store displays.' },
    { title: 'Step 2', content: ' Personalize the rewards and messages to match your business goals.' },
    { title: 'Step 3', content: 'Watch as customers eagerly engage and become loyal supporters of your brand.' }
  ]
  cardsHowItWorkHe=[
        {title:'שלב 1',content:'שלב את הכלי Spin to Win באתר האינטרנט שלך או בתצוגות בחנות.'},
        {title:'שלב 2 ',content:'התאימו אישית את התגמולים וההודעות כך שיתאימו ליעדים העסקיים שלכם.'},
        {title:'שלב 3 ',content:'צפה כיצד לקוחות מעורבים בהתלהבות והופכים לתומכים נאמנים של המותג שלך.'},
  ]
 
  scrollTo(id: string) {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }
}
